module.exports = __webpack_public_path__ + "static/media/주식 명의신탁.6493ae2d.png";